import {BaseFormModel} from './base-form-model';
import {MenuModifierSelectionOption} from './menu-modifier-selection-option';

export class MenuModifierSelection extends BaseFormModel<MenuModifierSelection> {
    id: number;
    name: string;
    description: string;
    required: boolean;
    minCount: number;
    maxCount: number;
    groupByModifier: boolean;
    options: MenuModifierSelectionOption[];
}
